const ADMIN_PAGE = {
  users: 'USERS',
  meetings: 'MEETINGS',
  coaches: 'COACHES',
  skills: 'SKILLS',
};

export default ADMIN_PAGE;
